import React, { Component } from 'react';
import kominfoTeam from '../assets/kominfo-team-10.png';
import Layout from '../layout/Main';
import MyAccount from '../components/Profiles/MyAccount';
import MyEvent from '../components/Profiles/MyEvent';

export default class Profiles extends Component {
  state = {
    activePage: 'myProfiles'
  }

  handleOnclick = (activePage) => {
    this.setState({activePage: activePage})
  }

  render() {
    return (
      <Layout>
        <section class="header-apa-psre">
          <img src={kominfoTeam} alt="kominfo-team" style={{width: '100%', height: 'auto'}}/>
        </section>
        <section class="nav-blue">
          <div class="container">
            <ul class="nav nav-pills pills-blue">
              <li class="nav-item" onClick={()=>this.handleOnclick('myProfiles')} style={styles.stylePointer}>
                <div class={`nav-link ${this.state.activePage === 'myProfiles' ? 'active' : ''}`} >
                  <i class="fas fa-user-shield mr-3"></i>
                  Akun Saya
                </div>
              </li>
              <li class="nav-item" onClick={()=>this.handleOnclick('myEvent')} style={styles.stylePointer}>
                <div class={`nav-link ${this.state.activePage === 'myProfiles' ? '' : 'active'}`} >
                  <i class="far fa-calendar-alt mr-3"></i>
                  Kegiatan Acara Saya
                </div>
              </li>
            </ul>
          </div>
        </section>
        {this.state.activePage === 'myProfiles' ? <MyAccount/> : <MyEvent/>}
      </Layout>
    )
  }
}

const styles = {
  stylePointer: {
    cursor: 'pointer'
  }
}
